import type { MuscleGroup } from '../types';

export const MUSCLE_GROUPS: MuscleGroup[] = [
  {
    name: 'Chest',
    description: 'Pectoral muscles for pushing movements',
    icon: 'Box',
    color: '#DC2626',
    targetAreas: ['Upper chest', 'Mid chest', 'Lower chest', 'Inner chest', 'Outer chest']
  },
  {
    name: 'Back',
    description: 'Posterior chain for pulling and posture',
    icon: 'Layers',
    color: '#EA580C',
    targetAreas: ['Upper back', 'Lats', 'Lower back', 'Traps', 'Rhomboids']
  },
  {
    name: 'Shoulders',
    description: 'Deltoids for overhead and lateral movements',
    icon: 'Triangle',
    color: '#D97706',
    targetAreas: ['Front delts', 'Side delts', 'Rear delts', 'Rotator cuff']
  },
  {
    name: 'Arms',
    description: 'Upper limb muscles for pull and push',
    icon: 'Maximize2',
    color: '#059669',
    targetAreas: ['Biceps', 'Triceps', 'Forearms', 'Brachialis']
  },
  {
    name: 'Core',
    description: 'Central stability and trunk control',
    icon: 'Disc',
    color: '#0284C7',
    targetAreas: ['Abs', 'Obliques', 'Transverse abdominis', 'Lower back']
  },
  {
    name: 'Upper Legs',
    description: 'Quads, hamstrings & glutes — hip and knee power',
    icon: 'ArrowDownUp',
    color: '#7C3AED',
    targetAreas: ['Quadriceps', 'Hamstrings', 'Glutes', 'Hip flexors']
  },
  {
    name: 'Lower Legs',
    description: 'Calves — ankle drive and stability',
    icon: 'Circle',
    color: '#DB2777',
    targetAreas: ['Calves', 'Gastrocnemius', 'Soleus', 'Tibialis']
  }
];

export const getMuscleGroupByName = (name: string): MuscleGroup | undefined => {
  return MUSCLE_GROUPS.find(group => group.name === name);
};

export const MUSCLE_GROUP_NAMES = MUSCLE_GROUPS.map(group => group.name);
